import { render, staticRenderFns } from "./comp3.vue?vue&type=template&id=144e9b56&scoped=true"
import script from "./comp3.vue?vue&type=script&lang=ts"
export * from "./comp3.vue?vue&type=script&lang=ts"
import style0 from "./comp3.vue?vue&type=style&index=0&id=144e9b56&prod&scoped=true&lang=scss"
import style1 from "./comp3.vue?vue&type=style&index=1&id=144e9b56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e9b56",
  null
  
)

export default component.exports